import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { EmonPriceProvider } from "@/contexts/EmonPriceContext";
import { FloatingBackButton } from "@/components/FloatingBackButton";

import Index from "./pages/Index";
import NotFound from "./pages/NotFound";
import Dashboard from "./pages/Dashboard";
import Mint from "./pages/Mint";
import Support from "./pages/Support";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import AntiFraud from "./pages/AntiFraud";
import Marketplace from "./pages/Marketplace";
import MarketplaceCategory from "./pages/MarketplaceCategory";
import Admin from "./pages/Admin";
import Analytics from "./pages/Analytics";
import Emon from "./pages/Emon";
import NftInfo from "./pages/NftInfo";

import PublicProfile from "./pages/PublicProfile";
import EarlyCreators from "./pages/EarlyCreators";
import Leaderboard from "./pages/Leaderboard";
import NftPage from "./pages/Nft";
import ShareNftRedirect from "./pages/ShareNftRedirect";
import HowItWorks from "./pages/HowItWorks";
import XShareBounce from "./pages/XShareBounce";
import AirdropChallenge from "./pages/AirdropChallenge";
import GameLanding from "./pages/GameLanding";
import GameMarketplace from "./pages/GameMarketplace";
import GameMint from "./pages/GameMint";
import GameDashboard from "./pages/GameDashboard";
import GameLeaderboard from "./pages/GameLeaderboard";
import GameCategoryPage from "./pages/GameCategoryPage";
import GameRoadmap from "./pages/GameRoadmap";
import GameMiniGame from "./pages/GameMiniGame";
import GameInvite from "./pages/GameInvite";
import GameResetPassword from "./pages/GameResetPassword";
import GameAdmin from "./pages/GameAdmin";


const queryClient = new QueryClient();

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <EmonPriceProvider>
        <TooltipProvider>
          <Toaster />
          <Sonner />
          
          <BrowserRouter>
            <FloatingBackButton />
            <Routes>
              <Route path="/" element={<Index />} />
              
              <Route path="/marketplace" element={<Marketplace />} />
              <Route path="/marketplace/recent" element={<MarketplaceCategory />} />
              <Route path="/marketplace/trending" element={<MarketplaceCategory />} />
              <Route path="/marketplace/most-expensive" element={<MarketplaceCategory />} />
              <Route path="/how-it-works" element={<HowItWorks />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/mint" element={<Mint />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/analytics" element={<Analytics />} />
              <Route path="/support" element={<Support />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/anti-fraud" element={<AntiFraud />} />
              <Route path="/profile/:identifier" element={<PublicProfile />} />
              <Route path="/nft/:id" element={<NftPage />} />
              <Route path="/share/nft/:id" element={<ShareNftRedirect />} />
              <Route path="/early-creators" element={<EarlyCreators />} />
              <Route path="/leaderboard" element={<Leaderboard />} />
              <Route path="/x-share-bounce" element={<XShareBounce />} />
              <Route path="/emon" element={<Emon />} />
              <Route path="/nft-info" element={<NftInfo />} />
              <Route path="/airdrop-challenge" element={<AirdropChallenge />} />
              
              {/* Game Routes */}
              <Route path="/game" element={<GameLanding />} />
              <Route path="/game/marketplace" element={<GameMarketplace />} />
              <Route path="/game/mint" element={<GameMint />} />
              <Route path="/game/dashboard" element={<GameDashboard />} />
              <Route path="/game/leaderboard" element={<GameLeaderboard />} />
              <Route path="/game/roadmap" element={<GameRoadmap />} />
              <Route path="/game/minigame" element={<GameMiniGame />} />
              <Route path="/game/invite" element={<GameInvite />} />
              <Route path="/game/reset-password" element={<GameResetPassword />} />
              
              <Route path="/game/admin" element={<GameAdmin />} />
              <Route path="/game/trending" element={<GameCategoryPage />} />
              <Route path="/game/most-expensive" element={<GameCategoryPage />} />
              <Route path="/game/recent" element={<GameCategoryPage />} />
              <Route path="/game/top-sellers" element={<GameCategoryPage />} />
              
              <Route path="*" element={<NotFound />} />
            </Routes>
          </BrowserRouter>
        </TooltipProvider>
      </EmonPriceProvider>
    </QueryClientProvider>
  );
}
